function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useMemo } from 'react';
import { TwoColumnContainer } from './TwoColumnContainer.js';
import { jsx } from 'react/jsx-runtime';
const FULL_PERCENTAGE = 100;
function TwoColumnLayout({
  mainContentPosition,
  mainContent,
  secondaryContent,
  mainContentPercentage = 50,
  secondaryContentPercentage = 50,
  mainContentPositionOnWrap = 'top',
  wrapOnTablet,
  gap
}) {
  const _useMemo = useMemo(() => {
      if (mainContentPosition === 'right') {
        return [secondaryContentPercentage, mainContentPercentage];
      }
      if (mainContentPosition === 'left') {
        return [mainContentPercentage, secondaryContentPercentage];
      }
      return [FULL_PERCENTAGE, FULL_PERCENTAGE];
    }, [mainContentPercentage, mainContentPosition, secondaryContentPercentage]),
    _useMemo2 = _slicedToArray(_useMemo, 2),
    leftPercentage = _useMemo2[0],
    rightPercentage = _useMemo2[1];
  const _useMemo3 = useMemo(() => {
      if (mainContentPosition === 'right' || mainContentPosition === 'bottom') {
        return [secondaryContent, mainContent, mainContentPositionOnWrap === 'top'];
      }
      return [mainContent, secondaryContent, mainContentPositionOnWrap === 'bottom'];
    }, [mainContentPositionOnWrap, mainContent, mainContentPosition, secondaryContent]),
    _useMemo4 = _slicedToArray(_useMemo3, 3),
    leftContent = _useMemo4[0],
    rightContent = _useMemo4[1],
    reverseOnWrap = _useMemo4[2];
  return /*#__PURE__*/jsx(TwoColumnContainer, {
    leftCol: leftContent,
    rightCol: rightContent,
    leftPercentage: leftPercentage,
    rightPercentage: rightPercentage,
    reverseOnWrap: reverseOnWrap,
    wrapOnTablet: wrapOnTablet,
    gap: gap
  });
}
export { TwoColumnLayout };
//# sourceMappingURL=TwoColumnLayout.js.map
